import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteProductDetailImageIn} from "../../../../../api/product/ProductInApi";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";


export const useDeleteProductDetailImageIn = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: {
            erpProductImageId: number,
            newErpProductid: string
        }) => deleteProductDetailImageIn(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "삭제되었습니다",
                type: "alert",
            });

            qc.invalidateQueries({queryKey: ["readProductDetailIn"]})
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
